import type { FC } from 'react'

import { cn } from '@/utils'

import { DimmedDuration } from '@/shared/ui/dimmed-duration'

import type { GroupTiming } from './group.types'

type GroupPlannedDurationProps = {
  groupTiming: GroupTiming
  className?: string
}

export const GroupPlannedDuration: FC<GroupPlannedDurationProps> = ({
  groupTiming,
  className,
}) => {
  return (
    <DimmedDuration
      className={cn('text-sm opacity-50', className)}
      ms={groupTiming.original.duration}
    />
  )
}
